export enum LabelsLabels {
  type = "type",
  dimensions = "dimensions",
  color = "color",
  print = "print",
}
